import { ThunkDispatch } from 'redux-thunk';
import { loginAs, logout } from '../actions';
import { Action, ActionType } from '../types/global_reducer';
import { ReduxState } from '../types/redux_types';

const checkForAuthenticatedUser = (
  store: {
    dispatch: ThunkDispatch<ReduxState, void, Action>;
  },
  isSDProTileEnabled: boolean
): void => {
  if (localStorage.getItem('id_token')) {
    const permissionedAccounts = localStorage.getItem('permissionedAccounts');
    const name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    const email = localStorage.getItem('email');
    const cob_unverified = /true/i.test(localStorage.getItem('cob_unverified') || '');
    if (permissionedAccounts && permissionedAccounts !== '[]') {
      store.dispatch({ type: ActionType.PAGE_REFRESH_LOADING });
      store.dispatch(
        loginAs({
          name: name || '',
          accountList: JSON.parse(permissionedAccounts),
          token: token || '',
          email: email || '',
          cob_unverified,
          isSDProTileEnabled,
        })
      );
    } else {
      store.dispatch(logout());
    }
  }
};

export default checkForAuthenticatedUser;
